import { cva } from '@/styled-system/css';

export const menuItemIconRecipe = cva({
  base: {
    gridArea: 'icon',
    width: 'Menu.ItemIcon.icon.width',
    height: 'Menu.ItemIcon.icon.height',
  },
  variants: {
    anchor: {
      true: {
        color: {
          base: 'Menu.ItemIcon.anchor.icon.default',
        },
      },
      false: {
        color: {
          base: 'Menu.ItemIcon.icon.default',
        },
      },
    },
    disabled: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      anchor: true,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Menu.ItemIcon.anchor.icon.hover',
          _groupActive: 'Menu.ItemIcon.anchor.icon.pressed',
        },
      },
    },
    {
      anchor: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Menu.ItemIcon.icon.hover',
          _groupActive: 'Menu.ItemIcon.icon.pressed',
        },
      },
    },
  ],
});
